import { useCallback, useEffect, useRef } from 'react';
import { Metrics } from '../metrics/Metrics';
export const useSegmentationFiltersInstanceContextPerformanceTracking = (isLoadingViewerData, onEditModeChange) => {
  // Track the time between mounting the filter editor and rendering a functional filter viewer
  const mountTimeRef = useRef(window.performance.now());
  useEffect(() => {
    if (!isLoadingViewerData) {
      // Mark the end time at the start of the next event loop
      //   so it more accurately reflects when the components are rendered.
      window.setTimeout(() => {
        // Uncomment to show timing in dev tools:
        // window.performance.measure('viewer_data_loaded', {
        //   start: mountTimeRef.current,
        // });
        Metrics.timer('viewer_data_loaded').update(window.performance.now() - mountTimeRef.current);
      }, 0);
    }
  }, [isLoadingViewerData]);

  // Track the time between initiating edit (for the first time)
  //   and rendering a functional edit experience
  const hasOpenedInEditMode = useRef(false);
  const firstEditInitiatedTimeRef = useRef();
  const onEditModeChangeTracked = useCallback(actionType => {
    if (actionType === 'EDITED_FILTERS') {
      if (!hasOpenedInEditMode.current) {
        hasOpenedInEditMode.current = true;
        firstEditInitiatedTimeRef.current = window.performance.now();

        // In the next event loop a functional edit experience will render
        window.setTimeout(() => {
          if (typeof firstEditInitiatedTimeRef.current !== 'undefined') {
            // Uncomment to show timing in dev tools:
            // window.performance.measure('editor_rendered', {
            //   start: firstEditInitiatedTimeRef.current,
            // });
            Metrics.timer('editor_rendered').update(window.performance.now() - firstEditInitiatedTimeRef.current);
          }
        });
      }
    }
    return onEditModeChange(actionType);
  }, [onEditModeChange]);
  return {
    onEditModeChangeTracked
  };
};